module.exports = __webpack_public_path__ + "img/BINANCE_COIN.8e821114.png";